import { registerSW } from 'virtual:pwa-register';
import { startApp } from './app';
import { initTheme } from './host-theme';
import './theme.js';
import './mobil.js';
import './offline.css';
import './design.css';
import './styles.css';

void initTheme();
registerSW({ immediate: true });

startApp(document.getElementById('root')!);
